<template>
  <div class="invitePk">
    <img class="posterBg" :src="invitePkBg" />
    <main>
      <section :class="[this.season + '_' + this.year]">
        <span
          :style="{
            visibility: posterData.segment_icon ? 'visible' : 'hidden',
          }"
          v-if="posterData.segment_id < 42"
          >{{ posterData.segment_level }}</span
        >
        <img class="stage_image"
          :style="{
            visibility: posterData.segment_icon ? 'visible' : 'hidden',
          }"
          :src="posterData.segment_icon ? posterData.segment_icon : inviteUrl"
        />
        <p
          :style="{
            visibility: posterData.segment_icon ? 'visible' : 'hidden',
          }"
        >
          <span>{{ posterData.segment_name }}段位</span>
        </p>
      </section>
      <section class="userInfo" :style="!isSpring ? 'top: -30px' : ''">
        <p>{{ posterData.service_name }}</p>
        <h3>{{ posterData.real_name }}</h3>
        <span
          >参加{{ subjectName }}PK赛
          {{ posterData.pk_count | formatNumberFilter }} 局，{{
            posterData.segment_name
          }}<template v-if="posterData.segment_id < 42"
            >{{ posterData.segment_level }}级</template
          >段位
        </span>
        <div :class="[this.season + '_' + this.year]">
          <dl>
            <dt>
              {{ posterData.ques_num | formatNumberFilter }}
            </dt>
            <dd>累计做题</dd>
          </dl>
          <dl>
            <dt>
              {{ posterData.pk_time_length }}
            </dt>
            <dd>学习时长(分钟)</dd>
          </dl>
          <dl>
            <dt>
              {{ posterData.pk_day_count | formatNumberFilter }}
            </dt>
            <dd>坚持天数(天)</dd>
          </dl>
        </div>
      </section>
      <footer :style="!isSpring ? 'top: -7vh' : ''">
        <div>
          <img :src="inviteUrl" />
          <p>长按识别二维码</p>
        </div>
        <div>
          <img src="../../../../assets/images/winterGame/poster/hand.png" />
          <p>要不要和taPK？</p>
        </div>
      </footer>
    </main>
  </div>
</template>

<script>
import { judgeTempSeason, compareTime } from "@/util/util.js";
export default {
  name: "invitePk",
  data() {
    return {
      isSpring: false,
      invitePkBg: null,
      year: "",
      season: "",
    };
  },
  props: {
    posterData: {
      type: Object,
      default: null,
    },
    inviteUrl: {
      type: String,
      default: "",
    },
    subjectName: {
      type: String,
      default: "",
    },
  },
  mounted() {
    this.initSeasonInfo();
    this.setInvitePkBg();
  },

  methods: {
    initSeasonInfo() {
      // 初始化基础季节信息
      [this.isSpring, this.year, this.season] = judgeTempSeason();
      
      // 从路由参数获取季节信息
      if (this.$route.params.seasonId) {
        const { seasonId } = this.$route.params;
        this.updateSeasonFromRoute(seasonId);
      }
    },

    updateSeasonFromRoute(seasonId) {
      // 更新季节信息
      const seasonMap = {
        'chunji': { isSpring: true, season: 'spring' },
        'xiaji': { isSpring: false, season: 'summer' },
        'qiuji': { isSpring: false, season: 'autumn' },
        'winter': { isSpring: false, season: 'winter' }
      };

      // 从 seasonId 中提取年份
      const yearMatch = seasonId.match(/s\.(\d{2})/);
      if (yearMatch) {
        this.year = `20${yearMatch[1]}`;
      }

      // 更新季节
      for (const [key, value] of Object.entries(seasonMap)) {
        if (seasonId.includes(key)) {
          this.isSpring = value.isSpring;
          this.season = value.season;
          break;
        }
      }
    },

    setInvitePkBg() {
      const officialGame = compareTime();
      const isOfficialGame = this.year === '2024' && officialGame;
      
      // 根据季节和比赛类型选择背景图片
      const imageType = this.isSpring || isOfficialGame ? 'study_report_official' : 'study_report';
      this.invitePkBg = require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/poster/${imageType}.png`);
    }
  }
};
</script>

<style lang="less" scoped>
.invitePk {
  display: flex;
  flex-direction: column;
  img.posterBg {
    width: 100%;
  }
  main {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }

  section {
    position: relative;
    &:first-child {
      > span {
        width: 21px;
        height: 48px;
        font-size: 36px;
        font-family: SourceHanSerifCN-SemiBold, SourceHanSerifCN;
        font-weight: 600;
        color: #ffffff;
        line-height: 52px;
        position: absolute;
        bottom: 33.3%;
        left: 48.5%;
        color: #ffffff;
      }
      img {
        width: 100%;
        margin-top: 180px;
        max-height: 600px;
      }
      p {
        position: relative;
        top: -60px;
        text-align: center;
        margin: 0;
        height: 100px;
        background: url("../../../../assets/images/winterGame/place/placeBg.png")
          no-repeat center;
        background-size: contain;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          display: inline-block;
          font-size: 32px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #efd193;
        }
      }
    }
    &.userInfo {
      text-align: center;
      position: relative;

      p {
        margin: 0;
        height: 34px;
        font-size: 34px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #ffffff;
        line-height: 52px;
      }
      h3 {
        margin: 24px 0;

        font-size: 80px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #ffffff;
      }
      span {
        height: 28px;
        font-size: 28px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #fbf497;
        line-height: 42px;
      }
      .summer_2023 {
        justify-content: center;
        margin-bottom: 62px;
        dl {
          // display: flex;
          // flex-direction: column;
          // align-items: center;
          // justify-content: center;
          dt {
            background: url("../../../../assets/images/squirrelCup/2023/summer/block.png")
              center no-repeat;
            background-size: contain;
            width: 220px;
            height: 104px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #ffffff;
          }
        }
      }
      .spring_2025 {
        justify-content: center;
        margin-bottom: 62px;
        dl {
          dt {
            background: url("../../../../assets/images/squirrelCup/2025/spring/poster/gold_bar_bg.png")
              center no-repeat;
            background-size: contain;
            width: 220px;
            height: 104px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #ffffff;
          }
        }
      }
      .summer_2025 {
        justify-content: center;
        margin-bottom: 62px;
        dl {
          dt {
            background: url("../../../../assets/images/squirrelCup/2025/summer/poster/gold_bar_bg.png")
              center no-repeat;
            background-size: contain;
            width: 220px;
            height: 104px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #ffffff;
          }
        }
      }
      .winter_2024 {
        justify-content: center;
        margin-bottom: 62px;
        dl {
          dt {
            background: url("../../../../assets/images/squirrelCup/2024/winter/poster/gold_bar_bg.png")
              center no-repeat;
            background-size: contain;
            width: 220px;
            height: 104px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #ffffff;
          }
        }
      }
      .summer_2024 {
        justify-content: center;
        margin-bottom: 62px;
        dl {
          dt {
            background: url("../../../../assets/images/squirrelCup/2024/summer/poster/gold_bar_bg.png")
              center no-repeat;
            background-size: contain;
            width: 220px;
            height: 104px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #ffffff;
          }
        }
      }
      div {
        margin-bottom: 86px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        dl {
          dt {
            height: 80px;
            font-size: 56px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #fbf497;
            line-height: 80px;
            text-align: center;
            margin: 0;
          }
          // .spring_2023 {
          //
          // }

          dd {
            margin: 0;
            height: 28px;
            font-size: 28px;
            font-family: SourceHanSansCN-Normal, SourceHanSansCN;
            font-weight: 400;
            color: #ffffff;
            line-height: 42px;
          }
        }
      }
    }
    &.summer_2024 {
      .stage_image {
        margin-top: 180px;
      }
    }
  }
  footer {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    div {
      &:first-child {
        img {
          width: 164px;
          height: 164px;
        }
        p {
          margin: 0;
          height: 34px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 34px;
        }
      }
      &:last-child {
        margin-left: 24px;
        img {
          width: 138px;
          margin-bottom: 16px;
        }
        p {
          margin: 0;
          height: 64px;
          font-size: 56px;
          font-family: CloudZongYiGBK;
          color: #ffffff;
          line-height: 64px;
        }
      }
    }
  }
}
</style>
